import { getPinia } from '@/createPiniaSingleton';
import { useReportFiltersStore } from '@/stores/reports/useReportFiltersStore';
(function () {
  angular.module('leanlaw').factory('reportsService', reportsService);
  reportsService.$inject = ['leanLawApi'];
  function reportsService(leanLawApi) {
    const service = {
      getReport: report,
      // Delegates to the one canonical builder shared with the generic engine.
      // See modules/reports/utils/reportQuery.ts.
      queryFromFilter: filter => useReportFiltersStore(getPinia()).queryFromLegacyFilter(filter),
      // probably obsolete
      entries,
      entriesClients,
      invoices,
      getAccountsFromEntries,
      getMattersFromEntries,
      getMattersFromInvoices,
      getClientReport: clientReport
    };
    return service;

    ///////////////////////////////////

    function entries(filter, $timeout) {
      let endDate;
      if (filter.filter.range && filter.filter.range.endDate) {
        endDate = new Date(filter.filter.range.endDate);
        endDate.setDate(endDate.getDate() + 1);
      }
      return leanLawApi.listEntries({
        account: !filter.filter.scopeAccount || filter.filter.scopeAccount.id === undefined ? '' : filter.filter.scopeAccount.id,
        scopeAccount: !filter.filter.scopeAccount || filter.filter.scopeAccount.id === undefined ? '' : filter.filter.scopeAccount.id,
        scope: filter.filter.scope,
        startDate: filter.filter.range.startDate,
        endDate: endDate ? endDate.toNetworkDate() : null,
        billed: filter.billed ? filter.billed.id || filter.billed : 'all',
        billedState: filter.billedFilter ? filter.billedFilter.id || filter.billedFilter : 'all',
        status: filter.status ? filter.status.id || filter.status : null,
        matterTag: filter.matterTag && filter.matterTag.id,
        $timeout
      });
    }
    function entriesClients(filter, $timeout) {
      let endDate;
      if (filter.filter.range && filter.filter.range.endDate) {
        endDate = new Date(filter.filter.range.endDate);
        endDate.setDate(endDate.getDate() + 1);
      }
      return leanLawApi.listEntriesClients({
        scopeAccount: !filter.filter.scopeAccount || filter.filter.scopeAccount.id === undefined ? '' : filter.filter.scopeAccount.id,
        scope: filter.filter.scope,
        startDate: !filter.filter.range.startDate ? '' : filter.filter.range.startDate,
        endDate: endDate ? endDate.toNetworkDate() : null,
        checked: 'true',
        status: filter.status ? filter.status.id || filter.status : null,
        billed: filter.billed ? filter.billed.id || filter.billed : 'all',
        billedState: filter.billedFilter ? filter.billedFilter.id || filter.billedFilter : 'all',
        matterTag: filter.matterTag && filter.matterTag.id,
        $timeout
      });
    }
    function clientReport(filter, $timeout) {
      let endDate;
      let startDate;
      const {
        range
      } = filter.filter;
      if (range && !filter.distributionId) {
        if (range.startDate) {
          startDate = range.startDate.toNetworkDate();
        }
        if (range.endDate) {
          const date = new Date(range.endDate);
          date.setDate(date.getDate() + 1);
          endDate = date.toNetworkDate();
        }
      }
      return leanLawApi.getReport({
        account: filter.account && filter.account.id ? filter.account.id : filter.account,
        primary: 'clients',
        source: filter.source || 'reports',
        reportType: filter.reportType,
        scopeAccount: !filter.filter.scopeAccount || filter.filter.scopeAccount.id === undefined ? '' : filter.filter.scopeAccount.id,
        scope: filter.filter.scope,
        startDate,
        endDate,
        billedState: filter.billedFilter ? filter.billedFilter.id || filter.billedFilter : 'all',
        distributionStatus: filter.distributionStatus ? filter.distributionStatus.id : null,
        distributionId: filter.distributionId,
        data: filter.data,
        billingType: filter.billingType,
        zeros: filter.zeros,
        // `billed` was assigned twice here; the later 'any' default silently won, so the
        // earlier 'all' one was dead. Removing the dead one, not changing the default.
        billed: filter.billed ? filter.billed.id || filter.billed : 'any',
        status: filter.status ? filter.status.id || filter.status : null,
        matterTag: filter.matterTag && filter.matterTag.id,
        secondary: filter.secondary ? filter.secondary : null,
        zerosKey: filter.zerosKey ? filter.zerosKey : null,
        $timeout
      });
    }
    function report(query, $timeout) {
      query.$timeout = $timeout;
      return leanLawApi.getReport(query);
    }
    function invoices(filter, $timeout) {
      let endDate;
      if (filter.filter.range && filter.filter.range.endDate) {
        endDate = new Date(filter.filter.range.endDate);
        endDate.setDate(endDate.getDate() + 1);
      }
      return leanLawApi.listInvoices({
        scopeAccount: !filter.filter.scopeAccount || filter.filter.scopeAccount.id === undefined ? '' : filter.filter.scopeAccount.id,
        scope: filter.filter.scope,
        startDate: filter.filter.range.startDate,
        endDate: endDate ? endDate.toNetworkDate() : null,
        processed: 'true',
        checked: 'true',
        status: filter.status ? filter.status.id || filter.status : null,
        matterTag: filter.matterTag && filter.matterTag.id,
        $timeout
      });
    }
    function getAccountsFromEntries(entries) {
      return _.map(_.uniq(entries, false, e => e.account.id), e => e.account);
    }
    function getMattersFromEntries(entries) {
      return _.map(_.uniq(entries, false, e => e.matter.id), e => e.matter);
    }
    function getMattersFromInvoices(invoices) {
      return _.map(_.uniq(invoices, false, e => e.matter.id), e => e.matter);
    }
  }
})();